// Awards methods
var Moment = require('moment');
Moment().format();

function getUnnaceptedRSUs(awards) {
    const results = awards.filter((el) =>
      (!el.acceptance_status || el.acceptance_status.code.toUpperCase() === 'U') &&
      el.shares_outstanding > 0);

    return results.sort(function(a,b) {
        return new Date(b.date) - new Date(a.date);
    })
}

function getUnacceptedRSUs(awards) {
    return getUnnaceptedRSUs(awards);
}

function getRSUs(awards, include_fully_vested = true) {
    return awards.filter((el) => isRSU(el) && (!el.fully_vested || include_fully_vested)).sort(function(a,b){
        return new Date(b.awarded_date) - new Date(a.awarded_date);
    })
}

function hasOptions(awards) {
    const result = awards.filter((el) => isOption(el))
    return result.length > 0
}

function getOptions(awards, include_fully_vested = true) {
    return awards.filter((el) => isOption(el) && (!el.fully_vested || include_fully_vested)).sort(function(a,b){
        return new Date(b.awarded_date) - new Date(a.awarded_date);
    })
}

function getFullyVestedAwards(awards, options_only = false) {
    if(options_only) {
        return awards.filter((el) => el.fully_vested && isOption(el)).sort(function(a,b){
            return new Date(b.awarded_date) - new Date(a.awarded_date);
        })
    }

    return awards.filter((el) => el.fully_vested).sort(function(a,b){
        return new Date(b.awarded_date) - new Date(a.awarded_date);
    })
}

function loadAward(awards, award_id) {
    var result = awards.find((el) => {return el.id === award_id })
    return result ? result : this.loadAwardByExtId(awards, award_id)
}

function loadAwardById(awards, awardId) {
  return awards.find((item) => { return item.id === awardId });
}

function loadAwardByExtId(awards, award_ext_id) {
    return awards.find((el) => {return el.amazon_award_id === award_ext_id })
}

function getPaymentMethods(awards, awardId, calendarYear) {
  let result

  if (calendarYear) {
    const { remaining } = getVestsByYear(awards, Moment({ year: calendarYear }).startOf('year'), Moment({ year: calendarYear }).endOf('year'), false)
    result = remaining.map(vest => vest.tax_election.code)
  } else {
    if (awardId) {
      const award = awards.find(award => award.id === awardId)
      result = award.vests.map(vest => vest.tax_election.code)
    } else {
      result = awards.map(award => award.tax_election.code)
    }
  }

  return [...new Set(result)]
}

function getVestsByYear(awards, start_date = null, end_date = null, group_by_year = true, start_calendar_month = null, end_calendar_month = null) {
    // 1. Extract all vests
    var result = awards.reduce((list, award) =>{
        // Here we can eliminate any unwanted vest
        var vests = award.vests
        if(start_date || end_date) {
            vests = award.vests.filter((vest) => {
                // Date criteria
                const vest_date = Moment(vest.vest_date, 'YYYY-MM-DD').toDate();

                if(start_date && end_date) {
                    return vest_date >= start_date && vest_date <= end_date
                }

                if(start_date) {
                    return vest_date >= start_date
                }

                if(end_date) {
                    return vest_date <= end_date
                }

                return null
            })
        }

        vests = vests.map((el) => {
            el["award_id"] = award.id
            return el
        })

        return list.concat(vests)

    },[])
    .sort((a, b) => {
        return new Date(a.vest_date) - new Date(b.vest_date);
    })

    if(group_by_year) {
        return result.reduce((groups, vest) =>{
            const vest_date = Moment(vest.vest_date, 'YYYY-MM-DD').toDate();

            const key = start_calendar_month ? calculate_year(start_calendar_month, end_calendar_month, vest_date)  : vest_date.getFullYear()
            groups[key] = groups[key] || {remaining: [], year: key, awards: [], remaining_rsus: 0}

            if(!vest.vested) {
                groups[key].remaining.push(vest)
            }

            // Count award?
            const val = groups[key].awards.find((el) => { return el === vest.award_id})

            if(!val) {
                groups[key].awards.push(vest.award_id)
            }

            // Count the Rsu
            if(!vest.vested) {
                groups[key].remaining_rsus += vest.vest_shares
            }

            return groups
        },{})
    } else {
        return result.reduce((groups, vest) => {
            if(!vest.vested) {
                groups.remaining.push(vest)
            }

            return groups
        },{remaining: []})
    }
}
function calculate_year(start_month, end_month, vest_date) {
    const start_date = new Date()
    start_date.setMonth(start_month-1, 1)
    start_date.setYear(vest_date.getFullYear())
    const end_date = new Date()
    end_date.setMonth(end_month - 1, 31)
    end_date.setYear(vest_date.getFullYear()+1)

    const m_start_date = Moment(start_date)
    const m_end_date = Moment(end_date)
    const m_vest_date = Moment(vest_date)

    if(m_vest_date.isBetween(m_start_date, m_end_date, 'day', '[]')) {
        return vest_date.getFullYear()
    } else if(m_vest_date.isBefore(m_start_date, 'day')) {
        return vest_date.getFullYear() - 1
    } else if(m_vest_date.isAfter(m_end_date, 'day')) {
        return vest_date.getFullYear() + 1
    }

}

function getNextVest(award) {
    const result = award.vests.filter((el) => !el.vested).sort(function(a,b){
        return new Date(a.vest_date) - new Date(b.vest_date);
    })

    return result[0] ? result[0] : null
}

function getUpcomingVests(awards) {
    // Extract all vests
    var result = awards.reduce((list, award) =>{
        // Only keep upcoming vests
        var vests = award.vests || []
        var today = new Date();

        // filter out options, vested, and dates less than or equal today
        vests = vests.filter((vest) => !this.isOption(award) && !vest.vested && (Date.parse(vest.vest_date) > today))

        vests = vests.map((el) => {
            el["award_id"] = award.amazon_award_id
            el["award_name"] = award.amazon_award_name
            el["awarded_date"] = award.awarded_date
            return el
        })

        return list.concat(vests)
    },[]).sort(function(a,b){ // sort first by vest_date asc, then award_date asc
        return new Date(a.vest_date) - new Date(b.vest_date) || new Date(a.awarded_date) - new Date(b.awarded_date);
    })

    return result
}

function getVestTaxRates(award) {
    var rates = award.vests.map((el) => {
        return el.fed_override_tax
    }).filter(t => !!t)

    if( rates && rates.length > 0 ) {
        var result = {
            min: Math.min(...rates),
            max: Math.max(...rates)
        }

        return result.min === result.max && result.min === award.fed_override_tax ? null : result
    }

    if(award.fed_override_tax) {
        return {
            min: award.fed_override_tax,
            max: award.fed_override_tax,
        }
    }

    return null
}

function getTaxRatesRange(list, default_tax_rate) {
  if (!Array.isArray(list)) {
    return default_tax_rate
  }

  const tax_rates = list.map(el => el.fed_override_tax)
  let result = [default_tax_rate]

  if (tax_rates.length > 0) {
    let min = Math.min(...tax_rates)
    let max = Math.max(...tax_rates)

    if (min === max) {
      result = [min]
    } else {
      result = [min, max]
    }
  }

  return result
}

function loadAwardWithVest(employee, award_id, vest_id) {
    // find the award
    const award = employee.awards.find(el => el.id === award_id)
    var vest = null

    if(award) {
        // now the vest
        vest = award.vests.find(vest=> vest.id === vest_id)
    }

    return  {
        award: award,
        vest: vest
    }
}

function loadAwardWithTransaction(employee, award_id, transaction_id) {
    // find the award
    const award = employee.awards.find(el => el.id === award_id)
    var transaction = null

    if(award) {
        // now the transaction
        transaction = award.transactions.find(transaction=> transaction.id === transaction_id)
    }

    return  {
        award: award,
        transaction: transaction
    }
}

function getTransactionsFromAward(award) {
    if(!award.transactions) {
        return null
    }
    return award.transactions.sort(function(a,b){
        return new Date(a.transaction_date) - new Date(b.transaction_date);
    })
}

function getVestsOptionsFromAward(award) {
    if(isOption(award)) {
       return getVestsFromAward(award, true)
    }

    return []
}

function getVestsFromAward(award, completed = true) {

    return award.vests.filter((el) => el.vested === completed).sort(function(a,b){
        return new Date(a.vest_date) - new Date(b.vest_date);
    })
}

function getTransactionsByYear(awards, start_date = null, end_date = null, group_by_year = true, start_calendar_month = null, end_calendar_month = null) {
    // 1. Extract all vests
    var result = awards.reduce((list, award) =>{
        // Here we can eliminate any unwanted vest
        var transactions = award.transactions || []

        if(start_date || end_date) {
            transactions = transactions.filter((transaction) => {
                // Date criteria
                const transaction_date = Moment(transaction.transaction_date, 'YYYY-MM-DD').toDate()
                
                if(start_date && end_date) {
                    return transaction_date >= start_date && transaction_date <= end_date
                }

                if(start_date) {
                    return transaction_date >= start_date
                }

                if(end_date) {
                    return transaction_date <= end_date
                }

                return null
                
            })
        }
        
        transactions = transactions.map((el) => {
            el["award_id"] = award.id
            return el
        })

        return list.concat(transactions)
            
    },[])
    .sort((a, b) => {
        return new Date(a.transaction_date) - new Date(b.transaction_date);
    })

    if(group_by_year) {
        return result.reduce((groups, transaction) =>{

            const transaction_date = Moment(transaction.transaction_date, 'YYYY-MM-DD').toDate();

            const key = start_calendar_month ? calculate_year(start_calendar_month, end_calendar_month, transaction_date)  : transaction_date.getFullYear()

            groups[key] = groups[key] || {completed: [], year: key, awards: [], completed_rsus: 0}

            groups[key].completed.push(transaction)

            // Count award?
            const val = groups[key].awards.find((el) => { return el === transaction.award_id})

            if(!val) {
                groups[key].awards.push(transaction.award_id)
            }

            // Count the Rsu
            groups[key].completed_rsus += transaction.shares_transacted

            return groups
        },{})
    } else {
        return result.reduce((groups, transaction) => {
            groups.completed.push(transaction)

            return groups
        },{completed: []})
    }
}

function getTransactionsAndVestsByYear(awards, start_date = null, end_date = null, group_by_year = true, start_calendar_month = null, end_calendar_month = null) {
    const group_vest = getVestsByYear(awards, start_date, end_date, group_by_year, start_calendar_month, end_calendar_month)
    const group_transactions = getTransactionsByYear(awards, start_date, end_date, group_by_year, start_calendar_month, end_calendar_month)

    if(group_by_year) {
        var c = {}

        Object.keys(group_vest).forEach((key) => {
            var obj = group_vest[key]
            if(group_vest[key] && group_vest[key].remaining.length > 0) {
                c[key] = { awards: group_vest[key].awards, remaining: group_vest[key].remaining, year: key, remaining_rsus: group_vest[key].remaining_rsus, rsus: obj.remaining_rsus };
            }
        });

        Object.keys(group_transactions).forEach((key) => {

            if(!c[key]) {
                c[key] = { awards: group_transactions[key].awards, completed: group_transactions[key].completed, year: key, completed_rsus: group_transactions[key].completed_rsus,  rsus: group_transactions[key].completed_rsus };
            } else {
                c[key].completed = group_transactions[key].completed
                c[key].completed_rsus = group_transactions[key].completed_rsus
                c[key].rsus = c[key].rsus + group_transactions[key].completed_rsus 
            }
        });

        return c
    } else {
        return {remaining: group_vest.remaining, completed: group_transactions.completed}
    }
}

function hasRole(roles, role) {
    return roles.find(el => el === role)
}

function getGenericNotifications(employee) {
    return employee.notifications.filter((el) => el.notification_class === 'INFO');
}

function getNonGenericNotifications(employee) {
    return employee.notifications.filter((el) => el.notification_class === 'ACT');
}

function reorderBrokerInfo(broker_info, employee) {
  const orderedBrokerInfo = broker_info

  if (employee.broker) {
    const currentBroker = orderedBrokerInfo.find(({ broker }) => broker.code === employee.broker.code)

    if(currentBroker != null) {
    const currentBrokerIndex = orderedBrokerInfo.indexOf(currentBroker)

        if (currentBrokerIndex !== 0) {
            orderedBrokerInfo.splice(currentBrokerIndex, 1)
            orderedBrokerInfo.unshift(currentBroker)
        }
    }
  }

  return orderedBrokerInfo
}

function getLanguageByCode(languages, code) {
    return languages.find((el) => {return el.code === code })
}

function canChangeAwardTaxRate(award) {
  return award.has_us_sourcing_in && !award.fully_vested;
}

function getAwardsForTaxElection(awards) {
    return awards.filter((el) => el.has_us_sourcing_in)
}
function getBrokerByCode(brokers, code) {
    return brokers.find((el) => {return el.code === code })
}

function isRSU(award) {
    return (award.award_type_code === '2' || award.award_type_code === '3')
}

function isOption(award) {
    return (award.award_type_code === '0' || award.award_type_code === '1' || award.award_type_code === '4')
}

function mapToBrokerComparisonUI(broker_info, featured) {
    var categories = []

    broker_info[0].broker_comparisons.forEach((comparison, index) => {
        if(comparison.featured === featured) {
            var vars = []
            comparison.children.forEach((child, index2) => {
                var values = []
                broker_info.forEach((broker) => {
                    values.push(broker.broker_comparisons[index].children[index2].content)
                })
                vars.push({
                    name: child.title,
                    values: values
                })
            })
            categories.push({
                title: comparison.title,
                vars:  vars
            })
        }
    })

    return categories
}

function awardsByDate(awards, start_date, end_date) {
   return awards.filter((award) => {
        // Date criteria
        const awarded_date = Moment(award.awarded_date, 'YYYY-MM-DD').toDate()

        if(start_date && end_date) {
            return awarded_date >= start_date && awarded_date <= end_date
        }

        if(start_date) {
            return awarded_date >= start_date
        }

        if(end_date) {
            return awarded_date <= end_date
        }

        return true
    })
}

function extractVestSchedule(award) {
    if(award.vest_schedule) {
        const lst = JSON.parse(award.vest_schedule)
        return lst.sort((a, b) => {
            return new Date(a.vest_date) - new Date(b.vest_date);
        })

    } else if(award.vests) {

       return award.vests.sort((a, b) => {
            return new Date(a.original_vest_date) - new Date(b.original_vest_date);
        }).map((vest) => {
            return {vest_date: vest.original_vest_date, vest_shares: vest.original_vest_shares}
        })
    }
    return []
}

function isAwardAccepted(award) {
    return award.acceptance_status && award.acceptance_status.code === "A";
}

function isBrokerChoiceOne(employee) {
    return employee.broker_choice_cd.toUpperCase() === 'ONE'
}

// Same as isBrokerChoiceOne but renamed for clarity for V2
function hasSingleBrokerChoice(employee) {
    return employee.broker_choice_cd.toUpperCase() === 'ONE'
}

function isBrokerChoiceNone(employee) {
    return employee.broker_choice_cd.toUpperCase() === 'NONE'
}

function isBrokerChoiceAll(employee) {
    return employee.broker_choice_cd.toUpperCase() === 'ALL'
}

function isBrokerChoiceDisable(employee) {
    return employee.broker_choice_cd.toUpperCase() === 'DISABLE'
}

function isZooxEmployee(employee) {
    return employee.hr_source_code.toUpperCase() === "ZOOX"
}

function isWholeFoodsEmployee(employee) {
    return employee.hr_source_code.toUpperCase() === "WFWD"
}

function isAPSEmployee(employee) {
    return employee.hr_source_code.toUpperCase() === "APS"
}

function isUserCode5Email(employee) {
    return employee.user_code_5 ? employee.user_code_5.toUpperCase() === "EMAIL" : false
}

function showAvailableBrokers(employee) {
    return true;
}

function showTaxElectionMessage(employee) {
    if ((employee.stock_preclear_code === 'C' && !employee.trading_window_in)
        || (employee.stock_preclear_code === 'D')) {
        return true;
    }
    else {
        return false;
    }
}

function getBrokersFromVest(t, awards, vest){
    var award = this.loadAward(awards, vest.award_id)

    return this.getBrokers(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)
}

function getBrokers(t, tax_broker_name, net_broker_name, mobile_tax_sale_in){

    if (tax_broker_name === "") {
        tax_broker_name = " ";
    }
    if (net_broker_name === "") {
        net_broker_name = " ";
    }

    if (!mobile_tax_sale_in && tax_broker_name !== "multiple"){
        return [net_broker_name]
    }

    if (tax_broker_name === "multiple"){
        return [t("VestingSummary.MultipleBrokers")]
    }
    else if (tax_broker_name === net_broker_name){
        return [tax_broker_name]
    }
    else {
        return [tax_broker_name, net_broker_name]
    }
}

function getBrokersDisplay(t, tax_broker_name, net_broker_name, mobile_tax_sale_in){
    if (!mobile_tax_sale_in && tax_broker_name !== "multiple"){
        return "<div>" + net_broker_name + "</div>"
    }

    if (tax_broker_name === "multiple"){
        return "<div>" + t("VestingSummary.MultipleBrokers") + "</div>"
    }
    else if (tax_broker_name === net_broker_name){
        return "<div>" + tax_broker_name + "</div>"
    }
    else {
        return "<div>" + tax_broker_name + "</div><div>" + net_broker_name + "</div>"
    }
}

function getBrokersCount(tax_broker_name, net_broker_name, mobile_tax_sale_in){
    if (!mobile_tax_sale_in || tax_broker_name === "multiple" || tax_broker_name === net_broker_name){
        return 1
    }
    else {
        return 2
    }
}

function getBrokersDisplayFromVest(t, awards, vest){
    var award = this.loadAward(awards, vest.award_id)

    return this.getBrokersDisplay(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)
}

function getBrokersCountFromVest(t, awards, vest){
    var award = this.loadAward(awards, vest.award_id)

    return this.getBrokersCount(award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)
}

function getEmployeeBrokerUrl(employee){
    if (employee && !this.isZooxEmployee(employee) && employee.broker && employee.broker.url){
        return employee.broker.url
    }
    else if (employee && this.isZooxEmployee(employee)){
        return process.env.REACT_APP_BROKER_SSO_ZOOX
    }
    else {
        return "#"
    }
}

function getBrokerUrl(broker, employee){
    if (employee && !this.isZooxEmployee(employee) && broker && broker.url){
        return broker.url
    }
    else if (employee && this.isZooxEmployee(employee)){
        return process.env.REACT_APP_BROKER_SSO_ZOOX
    }
    else {
        return "#"
    }
}

function getVestFractionalElectionText(t, employee, vest){
    // if the vest fractional indicator is null, use the employee's value

    if (vest && vest.fractional_share_in === true) {
        return t('StockAwards.FractionalSharesText')
    }
    else if (vest && vest.fractional_share_in === false) {
        return t('StockAwards.CashRefundText')
    }
    else {
        if (employee && employee.fractional_share_in){
            return t('StockAwards.FractionalSharesText')
        }
        else {
            return t('StockAwards.CashRefundText')
        }
    }
}

function hasFractionalEligibleVest(employee){
    var found = false

    employee.awards.every((award, index) => {
        if (award.vests.findIndex(v => v.fractional_share_eligible_in === true) > -1){
            found = true
            return false // break out of the loop
        }
        else {
            return true
        }
    })

    return found
}

const employeeService = {
    getUnnaceptedRSUs,
    getUnacceptedRSUs,
    getNextVest,
    getRSUs,
    getOptions,
    getFullyVestedAwards,
    getVestTaxRates,
    getTaxRatesRange,
    loadAwardWithVest,
    getVestsFromAward,
    getVestsByYear,
    loadAward,
    loadAwardById,
    loadAwardByExtId,
    getTransactionsAndVestsByYear,
    getTransactionsFromAward,
    getVestsOptionsFromAward,
    hasRole,
    hasSingleBrokerChoice,
    loadAwardWithTransaction,
    getGenericNotifications,
    getNonGenericNotifications,
    mapToBrokerComparisonUI,
    reorderBrokerInfo,
    getBrokerByCode,
    canChangeAwardTaxRate,
    getAwardsForTaxElection,
    getLanguageByCode,
    isRSU,
    isOption,
    awardsByDate,
    hasOptions,
    getPaymentMethods,
    extractVestSchedule,
    isAwardAccepted,
    isBrokerChoiceOne,
    isBrokerChoiceNone,
    isBrokerChoiceAll,
    isBrokerChoiceDisable,
    isWholeFoodsEmployee,
    isZooxEmployee,
    isAPSEmployee,
    isUserCode5Email,
    showAvailableBrokers,
    showTaxElectionMessage,
    getBrokersDisplay,
    getBrokersDisplayFromVest,
    getBrokersCount,
    getBrokersCountFromVest,
    getBrokersFromVest,
    getBrokers,
    getBrokerUrl,
    getEmployeeBrokerUrl,
    getUpcomingVests,
    getVestFractionalElectionText,
    hasFractionalEligibleVest
}

export default employeeService;
